export const STANDARDMODELS = ['language', 'sentiment'];

export const TOPICMODEL = 'topic';
